<div class="d-flex gap-1 align-items-center">
  <img class="notice-icon" src="assets/icons/grey/CircleExclamationMark.svg" alt="" />
  <span class="notice">
    <ng-container *ngIf="isLumpSum; else recurringNotice">
      <span *ngIf="replaces" class="sentence" i18n
        >This replaces the lump sum scheduled for {{ replaces.months }}.</span
      >
      <span *ngIf="cancels" class="sentence" i18n>This cancels the lump sum scheduled for {{ cancels.months }}.</span>
    </ng-container>
    <ng-template #recurringNotice>
      <ng-container *ngIf="replaces">
        <span *ngIf="replaces.isPlural; else replacesOne" class="sentence" i18n>
          This replaces the changes that were made for {{ replaces.months }}.
        </span>
        <ng-template #replacesOne>
          <span class="sentence" i18n>This replaces the change that was made for {{ replaces.months }}.</span>
        </ng-template>
      </ng-container>
      <ng-container *ngIf="cancels">
        <span *ngIf="cancels.isPlural; else cancelsOne" class="sentence" i18n>
          This cancels the changes that were made for {{ cancels.months }}.
        </span>
        <ng-template #cancelsOne>
          <span class="sentence" i18n>This cancels the change that was made for {{ cancels.months }}.</span>
        </ng-template>
      </ng-container>
    </ng-template>
  </span>
</div>
